import { render, staticRenderFns } from "./TourItem.vue?vue&type=template&id=3178a3e1&scoped=true&"
import script from "./TourItem.vue?vue&type=script&lang=js&"
export * from "./TourItem.vue?vue&type=script&lang=js&"
import style0 from "./TourItem.vue?vue&type=style&index=0&id=3178a3e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178a3e1",
  null
  
)

export default component.exports